import Accordion from 'react-bootstrap/Accordion';
import type { ReactNode } from 'react';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import {
  getCoverageGuide,
  type CoverageGuide,
} from '../lib/coverage-guides';

/** Shared body for coverage guides — data comes only from `getCoverageGuide`. */
export function CoverageGuideBody({
  guide,
  showTitle = true,
}: {
  guide: CoverageGuide;
  showTitle?: boolean;
}) {
  return (
    <div>
      {showTitle && (
        <div className="fw-semibold fs--1 mb-2">{guide.title}</div>
      )}
      {guide.paragraphs.map((paragraph, index) => (
        <p
          key={paragraph}
          className={
            index === guide.paragraphs.length - 1 ? 'mb-0 fs--1' : 'mb-2 fs--1'
          }
        >
          {paragraph}
        </p>
      ))}
    </div>
  );
}

/** Format guide title + paragraphs for the shared HelpTooltip. */
export function guideTooltipHtml(guide: {
  title: string;
  paragraphs: string[];
}): ReactNode {
  return (
    <>
      <strong className="d-block mb-1">{guide.title}</strong>
      {guide.paragraphs.map((paragraph, index) => (
        <span key={paragraph}>
          {index > 0 ? (
            <>
              <br />
              <br />
            </>
          ) : null}
          {paragraph}
        </span>
      ))}
    </>
  );
}

/** Collapsed by default: title only; click to read the full guide. */
export function CoverageGuideAccordion({ guide }: { guide: CoverageGuide }) {
  return (
    <Accordion className="onboarding-setup-guide-accordion">
      <Accordion.Item eventKey="0" className="border rounded-3 overflow-hidden">
        <Accordion.Header>
          <span className="fs--1 fw-semibold text-start">{guide.title}</span>
        </Accordion.Header>
        <Accordion.Body className="border-top pt-2 pb-3">
          <CoverageGuideBody guide={guide} showTitle={false} />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export function CoverageHelpTip({
  coverageState,
  placement = 'left',
}: {
  coverageState?: string | null;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
}) {
  const guide = getCoverageGuide(coverageState);
  if (!guide) return null;

  return (
    <HelpTooltip
      html={guideTooltipHtml(guide)}
      placement={placement}
      className="ms-1"
    />
  );
}
